import { NavLink, Outlet, Link } from "react-router-dom";
import { BarChart3, CalendarDays, ListOrdered, Menu, X } from "lucide-react";
import { useState } from "react";
import { TornaHome } from "@/components/Kpi";

const VOCI = [
  { to: "/dashboard-cq", label: "Report CQ", icon: BarChart3, testid: "nav-cq-report" },
  { to: "/calendario-cq", label: "Calendario", icon: CalendarDays, testid: "nav-cq-calendario" },
  { to: "/elenco-cq", label: "Elenco pratiche", icon: ListOrdered, testid: "nav-cq-elenco" },
];

/** Area CQ autonoma: tendina laterale nello stile del menu principale (Report, Calendario, Elenco). */
export default function LayoutCq() {
  const [open, setOpen] = useState(false);
  const linkCls = ({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-200
    ${isActive ? "bg-slate-100 text-slate-900 font-medium" : "text-slate-500 hover:bg-slate-50 hover:text-slate-900"}`;

  return (
    <div className="min-h-screen text-slate-900" style={{ background: "#F5F7FA" }} data-testid="layout-cq">
      <aside className={`fixed z-40 inset-y-0 left-0 w-64 bg-white border-r border-slate-200 flex flex-col
        transition-transform duration-200 lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`} data-testid="sidebar-cq">
        <div className="h-16 flex items-center px-6 border-b border-slate-200">
          <Link to="/scelta-canale" className="flex items-center gap-2" data-testid="brand-link-cq">
            <img src="/dbe-logo.png" alt="DBE Consulenza Finanziaria" className="h-8 w-auto" />
          </Link>
        </div>
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
          <div className="px-3 pb-2 text-[10px] uppercase tracking-[0.18em] font-semibold text-slate-400">Report CQ</div>
          {VOCI.map((v) => (
            <NavLink key={v.to} to={v.to} className={linkCls} data-testid={v.testid} onClick={() => setOpen(false)}>
              <v.icon size={16} /> {v.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      {open && <div className="fixed inset-0 z-30 bg-black/30 lg:hidden" onClick={() => setOpen(false)} />}
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid="cq-menu-toggle"
        className="lg:hidden fixed top-3 left-3 z-50 h-10 w-10 grid place-items-center rounded-md bg-white border border-slate-200 shadow">
        {open ? <X size={18} /> : <Menu size={18} />}
      </button>
      <main className="lg:pl-64 px-4 sm:px-8 py-8 pt-16 lg:pt-8">
        <div className="max-w-[1800px] mx-auto">
          <TornaHome testId="btn-torna-home-cq" />
          <Outlet />
        </div>
      </main>
    </div>
  );
}
